import { SelectItem } from 'types/embedded/selectItem';

export const enum Role {
  User = 'ROLE_USER',
  Manager = 'ROLE_MANAGER',
  Admin = 'ROLE_ADMIN',
  Finance = 'ROLE_FINANCE',
  FinanceLead = 'ROLE_FINANCE_LEAD',
  Payment = 'ROLE_PAYMENT',
  Risk = 'ROLE_RISK',
  Tech = 'ROLE_TECH',
  Observer = 'ROLE_OBSERVER',
}

export const FINANCE_ROLES = [Role.Finance, Role.FinanceLead];
export const PAYMENT_ROLES = [Role.Payment];
export const READ_ONLY_ROLES = [...FINANCE_ROLES, ...PAYMENT_ROLES, Role.Tech, Role.Risk];

export const ROLES_SELECT_ITEMS: SelectItem<Role>[] = [
  { id: Role.Admin, name: 'Админ' },
  { id: Role.Finance, name: 'Фин. отдел' },
  { id: Role.FinanceLead, name: 'Рук. фин. отдел' },
  { id: Role.Payment, name: 'Плат. отдел' },
  { id: Role.Risk, name: 'Риск. отдел' },
  { id: Role.Tech, name: 'Разработчик системы' },
];

export const enum MerchantSpacesRole {
  HeadManager = 'Head manager',
  FinanceManager = 'Finance manager',
  PaymentManager = 'Payment manager',
  RiskManager = 'Risk manager',
  Support = 'Support',
  Observer = 'Observer',
}
